/**
 * Message tracking
 */
export const MESSAGE_WIDGET_TRACK_VIEW = 'AR_MessageWidgetTrackView';
export const MESSAGE_WIDGET_TRACK_CLICK = 'AR_MessageWidgetTrackClick';

/**
 * Message widget mark
 */
export const MESSAGE_WIDGET_MARK_ID = 'AR_MessageWidgetMarkId';